import { Component, Input, inject } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { MatTooltip } from "@angular/material/tooltip"
import { HistoryDialogComponent } from "./history-dialog.component"

@Component({
    selector: "valben-history",
    standalone: true,
    template: `
        <button
            type="button"
            class="valben-row-action"
            [attr.aria-label]="tooltip"
            [matTooltip]="tooltip"
            (click)="open()">
            <mat-icon>{{ icon }}</mat-icon>
        </button>`,
    imports: [MatIcon, MatTooltip],
})
export class HistoryComponent {
    @Input() masterId!: string
    @Input() icon: string = "history"
    @Input() tooltip: string = "Povijest"

    private readonly _dialog = inject(MatDialog)

    open(): void {
        this._dialog.open(HistoryDialogComponent, {
            data: { masterId: this.masterId },
            width: "54rem",
            maxWidth: "calc(100vw - 2rem)",
        })
    }
}
